import Config from "@/const/Config";

export class StringUtil {
  static generateRandomString(length: number = 12) {
    // 使用する文字
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!"#$%&()=-'

    let randomStr = ''
    for (let i = 0; i < length; i++) {
      randomStr += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return randomStr
  }
}
